import { defineComponent as _defineComponent } from 'vue'
import type { TrendingSpotlightModuleFragment } from '@/features/onboarded-home/types';

import SpotlightModuleWithHorizontalScroll from '@/features/onboarded-home/components/modules/spotlights/SpotlightModuleWithHorizontalScroll.vue';
import TrendingSpotlightModuleCard from '@/features/onboarded-home/components/modules/spotlights/TrendingSpotlightModuleCard.vue';

import { CollectionType } from '@/enums/collection-type';
import { TitleOrder } from '@/enums/title-order';

import { calculateUrl } from '@/helpers/state-helper';

import { SnowplowTitleContextGraphql } from '@/helpers/tracking/providers';
import { useHomeModuleTracking } from '@/features/onboarded-home/tracking';
import { useRouter } from 'vue-router/composables';

import { computed } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'TrendingSpotlightModule',
  props: {
    moduleData: null,
    globalPosition: null,
    localPosition: null
  },
  setup(__props: any) {

const props = __props as {
	moduleData: TrendingSpotlightModuleFragment;
	globalPosition: number;
	localPosition?: number;
};



const router = useRouter();

const moduleTitle = computed(() => props.moduleData.translatables.title ?? undefined);

const showAllUrl = computed(() =>
	calculateUrl(router, undefined, CollectionType.POPULAR, { sort_by: TitleOrder.TRENDING }, {})
);

/* TRACKING */
const { moduleContext, moduleObserveVisibility, trackHomeModule } = useHomeModuleTracking({
	moduleData: () => props.moduleData,
	globalPosition: () => props.globalPosition,
	localPosition: () => props.localPosition,
	titleSize: () => props.moduleData.titles.length,
});

function trackTitleClicked(...contextData: Parameters<typeof SnowplowTitleContextGraphql.fromTitle>) {
	trackHomeModule('titleClicked', {
		spec: { label: moduleContext.value.type },
		contexts: [SnowplowTitleContextGraphql.fromTitle(...contextData)],
	});
}

return { __sfc: true,props, router, moduleTitle, showAllUrl, moduleContext, moduleObserveVisibility, trackHomeModule, trackTitleClicked, SpotlightModuleWithHorizontalScroll, TrendingSpotlightModuleCard }
}

})